import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { Message } from "primeng/message";

@Component({
  selector: "new-ui-formly-message",
  templateUrl: "./new-ui-formly-message.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Message],
})
export class NewUiFormlyMessageComponent extends FieldType {}
